export type ICheckAutoCompleteForMatch = (elm: IjQueryElmOrHtmlElm) => boolean;

export function checkAutoCompleteForMatch(elm: IjQueryElmOrHtmlElm): boolean {
  // element = element to validate (<input>)
  // value = value of the element (user input text)
  const $elm = $(elm);
  const val = $elm.val();
  const dropDown = $elm.autocomplete('widget');
  const $lis = $(dropDown).find('li');
  let hasMatch = false;

  // Loop through options and find if match is correct
  if ($lis.length) {
    $lis.each((_, _elm) => {
      const thisValue = $(_elm).text();
      if (thisValue === val) {
        hasMatch = true;
      }
    });
  }
  return hasMatch;
}
